import { useEffect, useState } from 'react';

// material-ui
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';

// project components
import IconButton from 'components/@extended/IconButton';
import { TaskManagementIcon } from 'utils/TaskManagementIcon/taskmanagemeneticon';
import TaskManagementDrawer from 'sections/taskManagement/TaskManagementDrawer';

import { useGetPermissions } from 'api/authUser';
import { hasReadPermission } from 'utils/permissions';
import { useSearchParams } from 'react-router';

// ==============================|| HEADER CONTENT - TASK MANAGEMENT ||============================== //

export default function TaskManagementHeaderIcon() {
  const featureID = 47;
  const { permissions } = useGetPermissions();
  const allowView = hasReadPermission(featureID, permissions);
  const [searchParams, setSearchParams] = useSearchParams();

  const [openDrawer, setOpenDrawer] = useState<boolean>(false);


  const handleToggleDrawer = () => {
    setOpenDrawer((prev) => !prev);
  };

  const handleCloseDrawer = () => {
    setOpenDrawer(false);
  };

  useEffect(() => {
    const shouldOpen =
      searchParams.get('openViewTaskPanel') === 'true' ||
      localStorage.getItem('openViewTaskPanel') === 'true';

    if (!shouldOpen || !allowView) return;

    setOpenDrawer(true);

    localStorage.removeItem('openViewTaskPanel');

    const params = new URLSearchParams(searchParams);
    params.delete('openViewTaskPanel');
    setSearchParams(params, { replace: true });
  }, [allowView]);

  if (!allowView) return null;

  return (
    <Box sx={{ flexShrink: 0, ml: 0.75 }}>
      <Tooltip title="Task Management">
        <IconButton
          color="secondary"
          variant="light"
          sx={(theme) => ({
            p: 0,
            color: 'text.primary',
            bgcolor: openDrawer ? 'grey.100' : 'transparent',
            ...theme.applyStyles('dark', { bgcolor: openDrawer ? 'background.default' : 'transparent' })
          })}
          onClick={handleToggleDrawer}
          aria-label="open task management drawer"
        >
          <TaskManagementIcon />
        </IconButton>
      </Tooltip>

      {openDrawer && <TaskManagementDrawer open={openDrawer} onClose={handleCloseDrawer} />}
    </Box>
  );
}
